// socket.js
import { io } from "socket.io-client";
import { IDS } from "./IDS";
// src/hooks/useSocket.js
import { useEffect } from "react";
export const socket = io(IDS.IMG_URL, {
    autoConnect: false,
    transports: ["websocket"] // faster than polling
});


export const useSocket = (event, callback) => {
    useEffect(() => {
        socket.on(event, callback);
        return () => {
            socket.off(event, callback); // cleanup on unmount
        };
    }, [event, callback]);
};

